import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const CompanyListss = ({ prRef }) => {
  const [data, setData] = useState([]);

  const getCompanies = async () => {
    try {
      const response = await axios
        .get("companies")
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {});
    } catch (error) {}
  };

  useEffect(() => {
    getCompanies();
  }, []);

  const columns = [
    "Id",
    "Company Name",
    "Contact Person",
    "Phone",
    "Address",
    "Balance",
    "Credit Limit",
    "Start Date",
    "End Date",
    "Status",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Company Information"}
        subTitle={""}
      />
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.id}</td>
              <td style={thTdStyle}>{trip.companyName}</td>
              <td style={thTdStyle}>{trip.contactPerson}</td>
              <td style={thTdStyle}>{trip.phoneNumber}</td>
              <td style={thTdStyle}>{trip.address}</td>
              <td style={thTdStyle}>{trip.balance}</td>
              <td style={thTdStyle}>{trip.creditLimit}</td>

              <td style={thTdStyle}>
                {new Date(trip.startDate).toLocaleString()}
              </td>
              <td style={thTdStyle}>
                {new Date(trip.endDate).toLocaleString()}
              </td>

              <td style={thTdStyle}>{trip.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export const exportExcelCorporateAccounts = async () => {
  const getCompanies = async () => {
    try {
      const response = await axios
        .get("companies")
        .then((res) => {
          const companiesWithFormattedDates = res.data.map((company) => ({
            Id: company.id,
            "Company Name": company.companyName,
            "Contact Person": company.contactPerson,
            Phone: company.phoneNumber,
            Address: company.address,
            Balance: company.balance,
            "Credit Limit": company.creditLimit,
            "Start Date": new Date(company.startDate).toLocaleString(),
            "End Date": new Date(company.endDate).toLocaleString(),
            Status: company.status,
          }));

          exportToExcel(companiesWithFormattedDates, "corporateAccounts", [
            "Id",
            "Company Name",
            "Contact Person",
            "Phone",
            "Address",
            "Balance",
            "Credit Limit",
            "Start Date",
            "End Date",
            "Status",
          ]);
        })
        .catch((err) => {});
    } catch (error) {}
  };
  getCompanies();
};

export default CompanyListss;
